module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("支付")]), _vm._v(" "), _c('mt-button', {
    on: {
      "click": _vm.authorize
    }
  }, [_vm._v("授权")]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/ticket/once"
    }
  }, [_vm._v("购票")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/order/all"
    }
  }, [_vm._v("我的订单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/coupon/gift"
    }
  }, [_vm._v("我的卡券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/myNewActivity"
    }
  }, [_vm._v("我的活动")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/activityList"
    }
  }, [_vm._v("活动列表")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/information"
    }
  }, [_vm._v("资讯列表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/coach/grade"
    }
  }, [_vm._v("教练列表")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rights"
    }
  }, [_vm._v("会员权益")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/mine"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("绑定手机号")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/getCoupon/1"
    }
  }, [_vm._v("领券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/userInfo"
    }
  }, [_vm._v("个人信息")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/error"
    }
  }, [_vm._v("Error")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/course"
    }
  }, [_vm._v("购课")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/orderBill/1"
    }
  }, [_vm._v("电子小票")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/myCourse/open"
    }
  }, [_vm._v("我的课程")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/subscribedCourse"
    }
  }, [_vm._v("已约课程")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/startedCourse"
    }
  }, [_vm._v("已上课程")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/subscribeCourse"
    }
  }, [_vm._v("预约课程")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/subscribeExperienceCourse"
    }
  }, [_vm._v("预约体验课")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/coursePay"
    }
  }, [_vm._v("课程支付")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/chooseCourse"
    }
  }, [_vm._v("选择课程")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "fixed-2"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a16e9d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 280
// module chunks = 94